export interface WarehouseShelfItem {
  id: string;
  title: string;
  description: string;
  platform: 'Chrome Extension' | 'Premiere Pro Plugin';
  image: string;
  url?: string;
}

export const googleExtensionShelf: WarehouseShelfItem[] = [
  {
    id: 'automatic-youtube-theater-mode',
    title: 'Automatic YouTube Theater Mode',
    description: 'Switch YouTube watch pages into theater mode.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/automatic-youtube-theater-mode.png',
    url: 'https://chromewebstore.google.com/detail/automatic-youtube-theater-mode/moamnkgdnhjdanhlnpbkefphielbjmmm',
  },
  {
    id: 'youtube-studio-analytics-export',
    title: 'YouTube Studio Analytics Export',
    description: 'Export Studio analytics to CSV.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/youtube-studio-analytics-export.png',
    url: 'https://chromewebstore.google.com/detail/youtube-studio-analytics-export/nedbjfncggljjdhggdleklpeppoloiaa',
  },
  {
    id: 'adjust-youtube-shorts-speed',
    title: 'Adjust YouTube Shorts Speed',
    description: 'Add speed controls to YouTube Shorts.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/adjust-youtube-shorts-speed.png',
    url: 'https://chromewebstore.google.com/detail/adjust-youtube-shorts-speed/ehcfphaakmaaamenfkajelpmhmeobhmo',
  },
  {
    id: 'youtool-io-extension',
    title: 'YouTool.io',
    description: 'Creator tools inside YouTube.',
    platform: 'Chrome Extension',
    image: 'https://64.media.tumblr.com/377e88f933f314338ba9608900174dc9/7c0180d0d1212074-5a/s1280x1920/a048ccb1bec91251584811a90d7551c9f7b4ceb7.pnj',
    url: 'https://chromewebstore.google.com/detail/youtoolio/goeiahdjdlokjnmebkdpohjgedfopnec',
  },
  {
    id: 'copy-youtube-video-description',
    title: 'Copy YouTube Video Description',
    description: 'Copy a YouTube description in one click.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/copy-youtube-video-description.png',
    url: 'https://chromewebstore.google.com/detail/copy-youtube-video-description/jbgdhdakbjdkgkhpbdheepngjidoaapb',
  },
  {
    id: 'auto-scroll-youtube-shorts',
    title: 'Auto-Scroll YouTube Shorts',
    description: 'Advance Shorts automatically when playback ends.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/auto-scroll-youtube-shorts.png',
    url: 'https://chromewebstore.google.com/detail/auto-scroll-youtube-shorts/dhekonpikmeigimepmfajlmajjfhgnea',
  },
  {
    id: 'show-youtube-shorts-views',
    title: 'Show YouTube Shorts Views',
    description: 'Show public view counts on Shorts.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/show-youtube-shorts-views.png',
    url: 'https://chromewebstore.google.com/detail/show-youtube-shorts-views/npohkhfoalnfcpgkoahiepnjmobmlhjh',
  },
  {
    id: 'loop-youtube-video',
    title: 'Loop YouTube Video',
    description: 'Add a loop toggle to YouTube videos.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/loop-youtube-video.png',
    url: 'https://chromewebstore.google.com/detail/loop-youtube-video/olknodjagiecmbdpfclgcphnoegnklhd',
  },
  {
    id: 'copy-youtube-video-tags',
    title: 'Copy YouTube Video Tags',
    description: 'Copy tags from YouTube watch pages.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/copy-youtube-video-tags.png',
    url: 'https://chromewebstore.google.com/detail/copy-youtube-video-tags/lcbkonnfbllpippdjlldbcemdgaeogof',
  },
  {
    id: 'save-youtube-video-screenshot',
    title: 'Save YouTube Video Screenshot',
    description: 'Save the current frame from a video.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/save-youtube-video-screenshot.png',
    url: 'https://chromewebstore.google.com/detail/save-youtube-video-screenshot/ckdeifomimomcoaabhcgjgieegmaagja',
  },
  {
    id: 'copy-youtube-video-transcript',
    title: 'Copy YouTube Video Transcript',
    description: 'Copy YouTube transcripts quickly.',
    platform: 'Chrome Extension',
    image: '/images/warehouse/google-extensions/copy-youtube-video-transcript.png',
    url: 'https://chromewebstore.google.com/detail/copy-youtube-video-transcript/lhpndclpdohdjmoecfjkdjcfiphojgdf',
  },
];

export const premierePluginShelf: WarehouseShelfItem[] = [
  {
    id: 'export-duplicate-source-uses',
    title: 'Export Duplicate Source Uses',
    description: 'Export repeated source usage reports.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-duplicate-source-uses.png',
  },
  {
    id: 'export-filtered-sources',
    title: 'Export Filtered Sources',
    description: 'Filter timeline sources and export matches.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-filtered-sources.png',
  },
  {
    id: 'export-missing-media-proxy-audit',
    title: 'Export Missing Media + Proxy Audit',
    description: 'Audit offline media and missing proxies.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-missing-media-proxy-audit.png',
  },
  {
    id: 'export-offline-clips',
    title: 'Export Offline Clips',
    description: 'Export active-sequence offline clips.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-offline-clips.png',
  },
  {
    id: 'export-proxy-gaps',
    title: 'Export Proxy Gaps',
    description: 'Export clips that need proxies.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-proxy-gaps.png',
  },
  {
    id: 'export-selected-clips-report',
    title: 'Export Selected Clips Report',
    description: 'Export a selected clips report.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-selected-clips-report.png',
  },
  {
    id: 'export-source-label-report',
    title: 'Export Source Label Report',
    description: 'Export source label indexes and use counts.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-source-label-report.png',
  },
  {
    id: 'export-stock-footage-sources',
    title: 'Export Stock Footage Sources',
    description: 'Export likely stock-footage sources.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-stock-footage-sources.png',
  },
  {
    id: 'export-timeline-source-list',
    title: 'Export Timeline Source List',
    description: 'Export every unique timeline source.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-timeline-source-list.png',
  },
  {
    id: 'export-used-media-paths',
    title: 'Export Used Media Paths',
    description: 'Export deduplicated media paths.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/export-used-media-paths.png',
  },
  {
    id: 'flash-frame-finder',
    title: 'Flash Frame Finder',
    description: 'Find one- or two-frame clips.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/flash-frame-finder.png',
  },
  {
    id: 'proxy-gap-finder',
    title: 'Proxy Gap Finder',
    description: 'Find clips missing attached proxies.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/proxy-gap-finder.png',
  },
  {
    id: 'select-adjustment-layers',
    title: 'Select Adjustment Layers',
    description: 'Select adjustment layers in a sequence.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-adjustment-layers.png',
  },
  {
    id: 'select-by-source-label',
    title: 'Select By Source Label',
    description: 'Select clips by source label.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-by-source-label.png',
  },
  {
    id: 'select-clips-shorter-than',
    title: 'Select Clips Shorter Than',
    description: 'Select clips below a chosen duration.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-clips-shorter-than.png',
  },
  {
    id: 'select-clips-under-playhead',
    title: 'Select Clips Under Playhead',
    description: 'Select clips touching the playhead.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-clips-under-playhead.png',
  },
  {
    id: 'select-disabled-clips',
    title: 'Select Disabled Clips',
    description: 'Select disabled timeline clips.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-disabled-clips.png',
  },
  {
    id: 'select-duplicate-source-uses',
    title: 'Select Duplicate Source Uses',
    description: 'Select repeated source uses.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-duplicate-source-uses.png',
  },
  {
    id: 'select-offline-clips',
    title: 'Select Offline Clips',
    description: 'Select clips with offline media.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-offline-clips.png',
  },
  {
    id: 'select-reversed-clips',
    title: 'Select Reversed Clips',
    description: 'Find reversed timeline clips.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-reversed-clips.png',
  },
  {
    id: 'select-same-source-as-selection',
    title: 'Select Same Source As Selection',
    description: 'Select matching source uses.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-same-source-as-selection.png',
  },
  {
    id: 'select-speed-changes',
    title: 'Select Speed Changes',
    description: 'Find speed changes and reverse speed.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/select-speed-changes.png',
  },
  {
    id: 'set-in-out-to-selection',
    title: 'Set In/Out To Selection',
    description: 'Set in and out points from selection.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/set-in-out-to-selection.png',
  },
  {
    id: 'silencecutter',
    title: 'SilenceCutter',
    description: 'Detect and remove silent sections.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/silencecutter.jpg',
  },
  {
    id: 'sync-it',
    title: 'Sync It',
    description: 'Prep and pack Premiere audio syncs.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/sync-it.png',
  },
  {
    id: 'timeline-clip-name-search',
    title: 'Timeline Clip Name Search',
    description: 'Select timeline clips by name.',
    platform: 'Premiere Pro Plugin',
    image: '/images/warehouse/premiere-plugins/timeline-clip-name-search.png',
  },
];
